var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLapin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_4",
    "data-name": "Calque 4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 902.55 1513.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#6a4a24;}.cls-4{fill:#9b7853;}.cls-5{fill:#11100f;}.cls-6{fill:#964a3b;opacity:0.51;}.cls-10,.cls-7,.cls-8,.cls-9{fill:#2d1c0a;}.cls-8{opacity:0.57;}.cls-9{opacity:0.56;}.cls-10{opacity:0.39;}.cls-11{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-474.45 -226)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M667,1676s-183-95-192-200,96-14,96-14-28-133,79-291S811,973,811,973s64-120,149-146c11-105,26-212,26-212l-20-47s-61-15-86-133,41-103,41-103,45,1,73,37l28,36s13-62,24-82c5-33,10-52,17-55s13,1,15,7,5,38,2,54,23,89,19,165c27,12,85,20,102,29s82,59,92,73,26,38,34,46,25,15,16,63c-5,25-23,30-27,30a77.21,77.21,0,0,0-10,1s-5,12-12,16-26,6-39,14-28,17-40,18c-5,27-17,40-16,47s0,48,12,64,25,33,17,100-34,59-38,86-30,77-25,93,15,35,13,89c3,58-7,97-7,97s4,27-9,59-92-53-92-53-49,161-86,186c-20,13-32,13-32,13s-7,15-3,17,54,26,75,26,40-4,50,16-51,25-51,25-74-6-95-7c-12-6-50-30-50-30l-39,44-2,7s68-13,85-9,69-2,85,77c-68,12-142,10-185,0S667,1676,667,1676Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Animal bord de la route") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M667,1676s-183-95-192-200,96-14,96-14-28-133,79-291S811,973,811,973s64-120,149-146c11-105,26-212,26-212l-20-47s-61-15-86-133,41-103,41-103,45,1,73,37l28,36s13-62,24-82c5-33,10-52,17-55s13,1,15,7,5,38,2,54,23,89,19,165c27,12,85,20,102,29s82,59,92,73,26,38,34,46,25,15,16,63c-5,25-23,30-27,30a77.21,77.21,0,0,0-10,1s-5,12-12,16-26,6-39,14-28,17-40,18c-5,27-17,40-16,47s0,48,12,64,25,33,17,100-34,59-38,86-30,77-25,93,15,35,13,89c3,58-7,97-7,97s4,27-9,59-92-53-92-53-49,161-86,186c-20,13-32,13-32,13s-7,15-3,17,54,26,75,26,40-4,50,16-51,25-51,25-74-6-95-7c-12-6-50-30-50-30l-39,44-2,7s68-13,85-9,69-2,85,77c-68,12-142,10-185,0S667,1676,667,1676Z",
    transform: "translate(-474.45 -226)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1161.3,642.29S1120,641,1117,622s20-43,36-42,30,13.65,29.5,24.83S1161.3,642.29,1161.3,642.29Z",
    transform: "translate(-474.45 -226)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1189,634s-15,14-38,6-29-19-19-36,33-19,41-10S1191,610,1189,634Z",
    transform: "translate(-474.45 -226)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1000,571s22-106,7-151-38-78-85-79-44,64-41,70,8,92,70,137C951,548,988,573,1000,571Z",
    transform: "translate(-474.45 -226)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1215,784s-104,25-143,4c-8.22-4.43-32-39-32-39s-2.2,43.94,26,77c25.68,30.1,80.17,49.28,114,55,16,3,24.68,0,24.68,0L1199,831S1212,802,1215,784Z",
    transform: "translate(-474.45 -226)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1171,1360s-6-114-38-136,82-103,82-103l23,277Z",
    transform: "translate(-474.45 -226)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1035,1666l-168.45-41.08S907,1607,922,1565s43-43,90-105,52-104,54-104,12,36,12,36l12,270Z",
    transform: "translate(-474.45 -226)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M569.05,1448s-5,92,26,126c-53-34-52-145-52-145Z",
    transform: "translate(-474.45 -226)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M982.64,607.1S1000,648,1012,652s27-15,26-18-72-63-72-63l-8,30Z",
    transform: "translate(-474.45 -226)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1019.29,401.51S1044,443,1049,472s6,42,6,42,6-17,32-19a406.85,406.85,0,0,0,49-7l-49-262-87,44Z",
    transform: "translate(-474.45 -226)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1306,736s-63,14-82-10,11-88,58-60,51-73,64-71,31,99,31,99l-42,46Z",
    transform: "translate(-474.45 -226)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1068.16,1360.12S1053,1348,1076,1317c0-46-63-73-72-100s19-110,19-110,38-27,39,44,35,93,45,121,15,128,36,135,15,26-11,51S1068.16,1360.12,1068.16,1360.12Z",
    transform: "translate(-474.45 -226)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M709,1650s-123.2-32.74-137-136-4-343-4-343L814,945s-115,363-35,526S829,1673,709,1650Z",
    transform: "translate(-474.45 -226)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 686.05,
    cy: 379.5,
    r: 5.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLapin);
export default __webpack_public_path__ + "static/media/lapin.eb0994ac0d008eb89e4224a9622c03d5.svg";
export { ForwardRef as ReactComponent };